'use client';

import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/buttons';
import {
  ScDescriptionAction,
  ScDescriptionContainer,
  ScDescriptionText,
} from '@/components/SeoDescription/components/client/styled';
import { ScBonusShopTermsText } from './styled';

interface BonusShopTermsProps {
  content: string;
  isExpanded: boolean;
  onToggle: () => void;
}

export const BonusShopTerms = forwardRef<HTMLDivElement, BonusShopTermsProps>(
  ({ content, isExpanded, onToggle }, ref) => {
    const { t } = useTranslation('common');

    if (!content) return null;

    return (
      <ScDescriptionContainer isExpanded={isExpanded} ref={ref}>
        <ScDescriptionText>
          <ScBonusShopTermsText dangerouslySetInnerHTML={{ __html: content }} />
        </ScDescriptionText>
        <ScDescriptionAction isExpanded={isExpanded}>
          <Button onClick={onToggle} paddingX={44} small whiteTransparent>
            {isExpanded ? t('showLessLong') : t('showMore')}
          </Button>
        </ScDescriptionAction>
      </ScDescriptionContainer>
    );
  }
);
